import { ControlledPopup, EllipsisDropdown, Person, Table } from 'dyl-components';
import React from 'react'
import { Dropdown, Header } from 'semantic-ui-react';

export default function TableRows({ billingContacts, onDeleteBillingContact }) {
    return billingContacts.map(contact => {
        const username = `${contact.user_full_name} ${contact.is_owner ? " (Owner)" : ""}`;
        return (
            <Table.Row key={contact.id} className={"BillingContactsTable__SmallFixedWidth"}>
                <Table.Cell>
                    <Person
                        username={
                            username
                        }
                        email={contact.user_email}
                    />
                </Table.Cell>
                <Table.Cell>
                    {!contact.is_owner && <EllipsisDropdown>
                        <ControlledPopup
                            header={<Header as='h4' textAlign='center'>
                                Are you sure?
                                <Header.Subheader style={{ marginTop: 5 }}>
                                    User will be removed as a billing contact.
                                </Header.Subheader>
                            </Header>}
                            trigger={<Dropdown.Item disabled={contact.is_owner} icon={'fas fa-trash-alt'} text={'Delete'} />}
                            onConfirm={() => { onDeleteBillingContact(contact.user_id); } } />
                    </EllipsisDropdown>}
                </Table.Cell>
            </Table.Row>
        );
    })
}
